/** Get Dashboard saas Top selling data */
/* REVENUE */
export const GET_DASHBOARD_REVENUE = "GET_DASHBOARD_REVENUE"
export const GET_DASHBOARD_REVENUE_SUCCESS = "GET_DASHBOARD_REVENUE_SUCCESS"
export const GET_DASHBOARD_REVENUE_FAIL = "GET_DASHBOARD_REVENUE_FAIL"

/* OCCUPANCY REPORT */
export const GET_DASHBOARD_OCCUPANCY = "GET_DASHBOARD_OCCUPANCY"
export const GET_DASHBOARD_OCCUPANCY_SUCCESS = "GET_DASHBOARD_OCCUPANCY_SUCCESS"
export const GET_DASHBOARD_OCCUPANCY_FAIL = "GET_DASHBOARD_OCCUPANCY_FAIL"

export const GET_LOTS_SOLD = "GET_LOTS_SOLD";
export const GET_LOTS_SOLD_SUCCESS = "GET_LOTS_SOLD_SUCCESS";
export const GET_LOTS_SOLD_FAIL = "GET_LOTS_SOLD_FAIL";
